import React from 'react';
import { FilterModal } from './ServiceRequestFilterModal/FilterModal';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import { ServiceRequestFilters } from 'src/pages/ServiceRequests/CustomHooks/useServiceRequestFilters';

interface FilterOverlayProps {
  showFilterOverlay: boolean;
  setShowFilterOverlay: (value: boolean) => void;
  filters: ServiceRequestFilters;
  applyFilters: (partial: Partial<ServiceRequestFilters>) => void;
}

export const FilterOverlay = ({
  showFilterOverlay,
  setShowFilterOverlay,
  filters,
  applyFilters,
}: FilterOverlayProps) => {
  return (
    <GenericDialogue
      isOpen={showFilterOverlay}
      onClose={() => setShowFilterOverlay(false)}
      title="Filter By"
      maxWidth="70rem"
    >
      <FilterModal
        onClose={() => setShowFilterOverlay(false)}
        filters={filters}
        applyFilters={applyFilters}
      />
    </GenericDialogue>
  );
};
